import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './metaPixel';

/**
 * Fires a Meta Pixel `PageView` event on every SPA route change.
 * The initial hard-load PageView is fired by index.html when consent is
 * granted, so this hook only handles subsequent client-side navigations.
 * Guarded by the consent gate inside metaPixel.js — safe to mount always.
 */
const useMetaPixelPageTracking = () => {
  const location = useLocation();
  useEffect(() => {
    trackPageView();
  }, [location.pathname, location.search]);
};

export default useMetaPixelPageTracking;
